import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Helmet } from "react-helmet";

import Header from "../Components/Header";
import Footer from "../Components/Footer";

const Section = ({ title, children }) => (
  <Box mb={4}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography color="text.secondary" lineHeight={1.8}>
      {children}
    </Typography>
  </Box>
);

const CookiePolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Cookie Policy – GroHair & GloSkin</title>
        <meta
          name="description"
          content="Learn how GroHair & GloSkin uses cookies to run this website, understand usage, and show relevant offers."
        />
      </Helmet>

      <Header />

      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          py: 6,
          mt: { xs: 10, md: 10 },
          bgcolor: "#fff",
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Cookie Policy
        </Typography>
        <Typography color="text.secondary" mb={4}>
          Last updated: 29 August 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Section title="1. What Are Cookies">
          Cookies are small text files that are placed on your device when
          you visit our website. They help us run the website properly,
          understand how visitors use it, remember your preferences, and
          show you relevant offers.
        </Section>

        <Section title="2. Types of Cookies We Use">
          <b>Necessary cookies</b> – required for the website to function
          (e.g. page navigation, security). These cannot be switched off.
          <br />
          <b>Analytics cookies</b> – help us understand how visitors interact
          with our website so we can improve it.
          <br />
          <b>Marketing cookies</b> – used to show you offers and content that
          are more relevant to you and your interests.
        </Section>

        <Section title="3. Your Choices">
          When you visit our website, you can choose to Accept All cookies,
          Reject non-essential cookies, or Customize your preferences.
          Necessary cookies will always remain active as they are essential
          for the website to work. You can change your cookie preferences at
          any time by clearing your browser cookies for this site and
          reloading the page.
        </Section>

        <Section title="4. Managing Cookies in Your Browser">
          Most web browsers allow you to control cookies through their
          settings. You can usually find these settings in the "Options" or
          "Preferences" menu of your browser. Please note that disabling
          certain cookies may affect the functionality of this website.
        </Section>

        <Section title="5. Changes to This Policy">
          We may update this Cookie Policy from time to time to reflect
          changes in technology, law, or our practices. Any changes will be
          posted on this page with an updated revision date.
        </Section>

        <Section title="6. Contact Us">
          If you have any questions about our use of cookies, please contact
          us at Kanchipuram@adgrohair.com or call +91 097510 56789.
        </Section>
      </Box>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
